 export default  [
  "#8E5572",
  "#E2B1B1",
  "#A3BF45",
  "#6C756B",
  "#9C93BE"
];